import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { AlertCircle, Clock, Brain, Battery } from 'lucide-react';
export function PainPoints() {
  const symptoms = [{
    icon: Clock,
    text: "Abres los ojos y tu cuerpo ya está 'encendido'."
  }, {
    icon: AlertCircle,
    text: 'Te da por revisar la hora (y ahí empieza el pánico).'
  }, {
    icon: Brain,
    text: "Intentas 'relajarte', pero se siente falso."
  }, {
    icon: Battery,
    text: 'Te quedas quieta, tratando de forzar el sueño… y mientras más lo fuerzas, más despierta estás.'
  }];
  return <section className="py-24 px-6 bg-slate-900 border-t border-slate-800" data-id="element-174">
      <div className="max-w-3xl mx-auto" data-id="element-175">
        <FadeIn data-id="element-176">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-12 text-center" data-id="element-177">
            Si despiertas entre 2 y 4am… <br data-id="element-178" />
            <span className="text-slate-400" data-id="element-179">esto probablemente te suene</span>
          </h2>
        </FadeIn>

        <div className="grid gap-6 mb-16" data-id="element-180">
          {symptoms.map((item, idx) => <FadeIn key={idx} delay={idx * 100} data-id="element-181">
              <div className="flex items-start gap-4 p-6 rounded-xl bg-slate-800/50 border border-slate-700/50 hover:border-amber-500/30 transition-colors" data-id="element-182">
                <item.icon className="w-6 h-6 text-amber-500 shrink-0 mt-1" data-id="element-183" />
                <p className="text-lg text-slate-200" data-id="element-184">{item.text}</p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={400} data-id="element-185">
          <div className="bg-slate-950 p-8 rounded-2xl border border-slate-800 text-center relative overflow-hidden" data-id="element-186">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-amber-500 to-transparent opacity-50" data-id="element-187"></div>
            <p className="text-xl text-slate-300 italic mb-6" data-id="element-188">
              "Hoy sobrevivo como pueda… y esta noche seguro vuelve a pasar."
            </p>
            <p className="text-lg text-slate-400" data-id="element-189">
              No es sólo cansancio. Es{' '}
              <strong className="text-amber-400" data-id="element-190">miedo anticipatorio</strong>.
              <br data-id="element-191" />
              Es ese pensamiento que te persigue desde la tarde: "Por favor que
              hoy no me toque."
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}